import { TRANSLATED_ACTIONS } from '@/common/messages';
import { APP_DICTIONARY } from '@/common/messages/root';
import { defineMessages } from '@/components/formatted_message/FormattedMessage';

export const Page = defineMessages({
  email: APP_DICTIONARY.email,
  continue: TRANSLATED_ACTIONS.continue,
  identifyError: {
    id: 'app.auth.identify.Page.identifyError',
  },
});
